import {makeStyles} from "@material-ui/core/styles"
import IconButton from "@material-ui/core/IconButton"
import {Icon} from "@material-ui/core"
import React from "react"
import UserEvent from "../../core/UserEvent"
import i18n from "../../core/i18n"
import PropTypes from "prop-types"

const useStyles = makeStyles(theme => ({
    root: {
        borderRadius: '0px',
        padding: '0',
    },
    label: {
        padding: '0.3em',
        borderRadius: '0px',
    }
}))

function ToolButton(props) {
    const {value, icon, style = {}, onClick, 'aria-label': ariaLabel} = props
    const classes = useStyles()

    const handleMouseDown = event => {
        event.preventDefault()
        onClick && onClick(new UserEvent({value}, event))
    }

    const title = i18n.translate(props.title)

    return (
        <IconButton value={value} classes={classes} style={style} onMouseDown={handleMouseDown}
                    title={title} aria-label={i18n.translate(ariaLabel) || title} >
            <Icon fontSize="small" >{icon}</Icon>
        </IconButton>
    )
}

ToolButton.propTypes = {
    value: PropTypes.string,
    icon: PropTypes.oneOfType([PropTypes.string, PropTypes.string]),
    style: PropTypes.object,
    onClick: PropTypes.func,
    title: PropTypes.string,
    'aria-label': PropTypes.string,
}

export default ToolButton